// Vendor Components
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {isEmpty} from 'lodash';
import {push} from 'redux-first-history';
import { Outlet } from 'react-router';

// Actions
import {closeAllOverlays} from '../../../actions/overlay-actions';

// Components
import GlobalResponse from '../../core/global-response';
import Heartbeat from '../../core/heartbeat';
import Login from '../../core/login';
import MainHeader from './main-header';
import OverlayPortal from '../../core/overlay-portal';

// Contexts
import {RouteContext} from '../../../contexts/route-context';

class Main extends Component {
    getProps() {
        return {
            onClick: this.handleClick,
        };
    }

    handleClick = () => {
        const {closeAllOverlays, overlays} = this.props;

        if (!isEmpty(overlays)) {
            closeAllOverlays();
        }
    };

    render() {
        const {children, location, push, routerParams} = this.props;

        return (
            <div className="main" {...this.getProps()}>
                <MainHeader />
                <Heartbeat />
                <Login>
                    <RouteContext.Provider
                        value={{
                            location,
                            push,
                            routerParams,
                        }}
                    >
                        <div className="main--content">{children}</div>
                        <Outlet />
                    </RouteContext.Provider>
                </Login>
                <OverlayPortal />
                <GlobalResponse />
            </div>
        );
    }
}

Main.propTypes = {
    children: PropTypes.node,
    closeAllOverlays: PropTypes.func.isRequired,
    location: PropTypes.object,
    overlays: PropTypes.object,
    push: PropTypes.func.isRequired,
    routerParams: PropTypes.object,
};

const mapStateToProps = ({overlays, router: {location, routerParams} = {}}) => ({
    location,
    overlays,
    routerParams,
});

const mapDispatchToProps = {
    closeAllOverlays,
    push,
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
